var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBugReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 2 1.88 1.88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.12 3.88 16 2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20v-9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53 9C4.6 8.8 3 7.1 3 5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13H2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21c0-2.1 1.7-3.9 3.8-4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.97 5c0 2.1-1.6 3.8-3.5 4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13h-4"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 17c2.1.1 3.8 1.9 3.8 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBugReports);
export default __webpack_public_path__ + "static/media/bug_reports.3e18efb20cf93d1bc0b5eb2d44f69c14.svg";
export { ForwardRef as ReactComponent };